import { render, staticRenderFns } from "./printSetting_m.vue?vue&type=template&id=0a2dee9b&"
import script from "./printSetting_m.vue?vue&type=script&lang=ts&"
export * from "./printSetting_m.vue?vue&type=script&lang=ts&"
import style0 from "./printSetting_m.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports